import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const ShowErrorMsg = ({ error }) => {
  return (
    <Box sx={{
      maxWidth:600,
      mb:2,
   //   backgroundColor: '#ff9800',
    backgroundColor: '#efbfef',
      p: 1,
      boxShadow: 6, // MUI shadow scale from 0 to 24
      // transform: 'rotateX(5deg) rotateY(10deg)', // slight 3D rotation
      // transition: 'transform 0.3s ease-in-out', // smooth transition on hover
      // '&:hover': {
      //   transform: 'rotateX(10deg) rotateY(20deg) scale(1.05)', // increased rotation and scale on hover
      //   boxShadow: 10, // deeper shadow on hover
      // }
    }}>
      <Typography variant="body1" component="p" sx={{ color: '800000' }}>
        {error}
      </Typography>
    </Box>
  );
}
export default ShowErrorMsg;